<template>
  <section id="solution-focused" class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-[#f0f2f5]">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
      <div class="text-center mb-10 sm:mb-12 md:mb-16">
        <h2
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#0b105d] mb-4"
          data-aos="fade-up"
        >
          {{ $t('solutionFocused.title') }}
        </h2>
        <div
          class="w-16 sm:w-20 md:w-24 h-1 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mx-auto"
          data-aos="fade-up"
          data-aos-delay="100"
        ></div>
      </div>

      <div class="relative">
        <div
          class="hidden lg:block absolute top-8 sm:top-10 left-0 w-full h-0.5 bg-gradient-to-r from-[#fe6d0d]/30 via-[#ffb47c]/30 to-[#fe6d0d]/30"
          style="z-index: 0"
        ></div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 sm:gap-8">
          <div
            v-for="(step, index) in solutionFocusedSteps"
            :key="index"
            class="relative group"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
          >
            <div
              class="absolute -inset-0.5 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] rounded-2xl blur opacity-20 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"
            ></div>
            <div
              class="relative bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col"
            >
              <div class="relative mb-4 sm:mb-6">
                <div
                  class="absolute -top-2 -right-2 sm:-top-3 sm:-right-3 w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full group-hover:scale-110 transition-transform duration-300"
                ></div>
                <div
                  class="relative z-10 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-xl sm:rounded-2xl flex items-center justify-center text-white text-lg sm:text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300"
                >
                  {{ index + 1 }}
                </div>
              </div>
              <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
                {{ $t(step.titleKey) }}
              </h3>
              <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
                {{ $t(step.descriptionKey) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const solutionFocusedSteps = ref([
  { titleKey: 'solutionFocused.step1', descriptionKey: 'solutionFocused.step1_desc' },
  { titleKey: 'solutionFocused.step2', descriptionKey: 'solutionFocused.step2_desc' },
  { titleKey: 'solutionFocused.step3', descriptionKey: 'solutionFocused.step3_desc' },
  { titleKey: 'solutionFocused.step4', descriptionKey: 'solutionFocused.step4_desc' },
  { titleKey: 'solutionFocused.step5', descriptionKey: 'solutionFocused.step5_desc' }
])
</script>
